import { Link } from "react-router";

// Card click -> pehle Mediator page (/watch/:slug/:id), wahan countdown ke baad GET LINK
export default function Card({ item, slug }) {
  return (
   <div className="relative">
  <Link
    to={`/watch/${slug}/${item.id}`}
    className="group block rounded-2xl border border-line bg-panel p-3 transition hover:-translate-y-0.5 hover:border-glow focus-visible:outline-2 focus-visible:outline-glow"
  >
    {/* Image Container */}
    <div className="relative object-cover w-full overflow-hidden rounded-xl bg-line">
      {item.img ? (
        <img
          src={item.img}
          alt={item.title}
          loading="lazy"
          className="size-full object-cover transition duration-300 group-hover:scale-105"
        />
      ) : (
        <div className="grid size-full place-items-center bg-gradient-to-br from-line to-panel text-sm text-mist">
          Image
        </div>
      )}
    </div>

    {/* Mobile pe responsive layout (Column on mobile, Row on larger screens) */}
   <div className="mt-2 flex flex-col justify-between gap-1 sm:flex-row sm:items-center sm:gap-2 min-w-0">
  <p className="font-display text-sm font-bold sm:text-base break-words [overflow-wrap:anywhere] min-w-0 flex-1">
    {item.title}
  </p>
  <p className="shrink-0 whitespace-nowrap font-display text-xs font-bold text-red-600  sm:text-sm">
    {item.dow}
  </p>
  
</div>
   <p className=" shrink-0 whitespace-nowrap font-display text-xl font-bold text-sky-300 sm:text-xl animate-bounce ">
    {item.upd}
    </p>
  </Link>



    {/* ads */}


       
    </div>
  );
}
